import React, { useEffect, useMemo, useRef } from 'react';
import { useCruise } from '../../hooks/use-cruise';
import { useDay } from '../../hooks/use-day';
import { formatPortName, groupItineraryDays } from '../../utils/cruise';
import { ExcursionList } from '../excursion-list/excursion-list';
import classes from './day-overview.module.css';

/**
 * @returns {React.JSX.Element}
 */
export function DayOverview() {
  const { data: cruise } = useCruise();
  const { getCurrentDayNumber, viewAllDays } = useDay();
  const dayNumber = getCurrentDayNumber();

  const days = useMemo(() => groupItineraryDays(cruise), [cruise]);
  const day = useMemo(() => days.find((day) => day.dayNumber === dayNumber), [days, dayNumber]);
  const contentRef = useRef(/** @type {HTMLDivElement | null} */ (null));

  useEffect(() => {
    contentRef.current?.scrollTo({ top: 0 });
  }, [dayNumber]);

  return (
    <div className={classes.dayOverview}>
      <div className={classes.header}>
        <button type="button" className={classes.btnAllDays} onClick={viewAllDays}>
          {'<'} All Days
        </button>
        <h1 className={classes.title}>Day {day?.dayNumber}</h1>
      </div>
      <div style={{ position: 'relative', flex: 'auto' }}>
        <div ref={contentRef} className={classes.content}>
          {day?.ports.map((port, index) => (
            <div key={index} className={classes.port}>
              <div className={classes.portOverview}>
                <h1 className={classes.portTitle}>
                  {index === 0 && <span className={classes.portDay}>Day {day?.dayNumber}:</span>}
                  <span className={classes.portName}> {formatPortName(port)}</span>
                </h1>
                <p className={classes.portDescription}>{port.longDescription}</p>
              </div>
              <div className={classes.portImage}>
                <img src={port.image.url} loading="lazy" alt={port.image.caption ?? ''} />
              </div>
            </div>
          ))}
          {day && (day.excursions.length ?? 0) > 0 && <ExcursionList day={day} />}
        </div>
      </div>
    </div>
  );
}
